import { EEventType } from './../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import { IOYSelectState, IOYSelectProps } from "./const";
import OY from '../../types/OY';
import { jeact } from '../../decorators/jeact';

@jeact({ autoRender: true })
export default class OYSelect extends OY<IOYSelectProps, IOYSelectState> {
  static displayName = 'OYSelect';

  static defaultProps: Partial<IOYSelectProps> = {
    value: '',
    info: [],
    size: 'small',
    simple: false,
    align: "left",
    placeholder: '请选择',
    hideLabelValue: false,
    nameStyle: {}
  };

  state: IOYSelectState = {
    current: {
      name: '',
      value: ''
    }
  }

  $node = {
    icon: $(),
    dropdown: $()
  }

  isCalc = false;

  getDerivedStateFromProps(prop: IOYSelectProps, state: IOYSelectState) {
    const { value, info = [] } = prop;
    let statecCurrent = this.state.current;
    if (prop.value) {
      const current = info.find(va => va.value === value);
      if (current) {
        statecCurrent = current;
      }
    }
    return { ...state, current: statecCurrent }
  }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  setNode() {
    this.$node = {
      icon: this.$el.find(`.${styles.icon}`),
      dropdown: this.$el.find(`.${styles.dropdown}`)
    }
  }

  bindElClick() {
    this.$el.click((ev: Event) => {
      ev.stopPropagation();
      this._triggerBodyClick();
    })

    this.$class(styles.dropdown).click((ev: Event) => {
      ev.stopPropagation();
    })
  }

  bindInfoClick() {
    this.$class(styles.info).click((event: Event) => {
      if (!this.$el.hasClass(styles.active)) {
        setTimeout(() => {
          $(document.body).one('click', this.documentClickHandler.bind(this))
        });
        this.$el.addClass(styles.active)
        this.calcPosition();
      } else {
        this._triggerBodyClick();
      }
    })
  }

  bindOptionClick() {
    this.$node.dropdown.delegate(`.${styles.dropdown_item}`, 'click', (event: Event) => {
      // event.stopPropagation();
      const $this = $(event.currentTarget!);
      const value = $this.data('value').toString();
      if (value === this.state.current.value) {
        return;
      }

      const current = (this.props.info || []).find(va => va.value === value)!;
      this.setState({ current });
      this.eventEmitter.emit(EEventType.onChange, value);
      this._triggerBodyClick();
    })
  }

  private documentClickHandler(event: Event) {
    this.$el.removeClass(styles.active);
  }

  private _triggerBodyClick() {
    $(document.body).trigger('click')
  }

  private calcPosition() {
    if (!this.isCalc) {
      const { width } = this.$class(styles.info).get(0).getBoundingClientRect();
      const $dropDown = this.$class(styles.dropdown);
      $dropDown.css({
        left: -Math.floor(($dropDown.outerWidth() - width) / 2)
      })
      this.isCalc = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/OYSelect/index.ts